import { render } from "./Object.vue?vue&type=template&id=2a1c5b2c&lang=pug"
import script from "./Object.vue?vue&type=script&lang=ts"
export * from "./Object.vue?vue&type=script&lang=ts"
script.render = render

export default script